export default __webpack_public_path__ + "static/media/roadmap_6.fb5a490b.png";